import React from 'react';
import { Star, Quote } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from './ui/carousel';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Denise Ramos',
      text: 'Melhor local que encontrei para gravação: imagem e som de extrema qualidade, pessoal gente boa, entregam o vídeo na hora, só elogios! Obrigada :)',
      rating: 5,
    },
    {
      name: 'Daniela Rebeca',
      text: 'Excelente estúdio. Estamos gravando um treinamento para o lugar onde trabalho e só tenho a agradecer ao Mariano e equipe, por todas as ideias, sugestões e paciência em conduzir as gravações e edições para que seja produzido um treinamento online com excelência. Valeu!',
      rating: 5,
    },
    {
      name: 'Mariana Schreiber',
      text: 'Sou jornalista e tenho gravado alguns vídeos no Hertz. Serviço de qualidade e atendimento profissional',
      rating: 5,
    },
    {
      name: 'Larissa Coimbra',
      text: 'ótimo atendimento e ótimo serviço prestado! pretendo voltar a trabalhar com o estúdio na produção das minhas músicas autorais, muito bom o trabalho. super indico',
      rating: 5,
    },
    {
      name: 'Keit Guimarães',
      text: 'Qualidade impecável em todos os sentidos! Recomendo demais!',
      rating: 5,
    },
    {
      name: 'Alline Cristina da Silva',
      text: 'O studio é ótimo. Alta qualidade',
      rating: 5,
    },
    {
      name: 'Alexandre Freire Ribeiro',
      text: 'Simplesmente sensacional.....um grande músico um grande coração e agora um grande amigo ....me mostrou o q eu não era capaz de ver e com o seu talento ( Mariano) me possibilitou sonhar ......OBRIGADO!!!!!!!\n\nAgora fizemos um EP Dois Singulares..contando com toda a sensibilidade do mestre Mariano...está tocando em Brasília e em outras capitais do Brasil...obrigado meu amigo por emprestar a esse EP sua genialidade',
      rating: 5,
    },
    {
      name: 'Jorge Salomao',
      text: 'Indiscutivelmente a melhor qualidade do DF num preço justo. Equipamentos muito bons, conservados, tratamento acústico impecável, fora a competência técnica e musical do produtor Mariano Jr. RECOMENDO',
      rating: 5,
    },
    {
      name: 'Fabio Doreto',
      text: 'Excelente opção para quem quer produzir sua música de forma remota! Você manda sua ideia e o Mariano vai fazer acontecer!',
      rating: 5,
    },
  ];

  return (
    <section id="depoimentos" className="py-16 bg-gradient-to-b from-white to-gray-50 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-20 right-0 w-96 h-96 bg-[#ff6b35]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 left-0 w-96 h-96 bg-[#48a9a6]/5 rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-12 space-y-4">
          <div className="inline-block">
            <span className="text-[#ff6b35] font-semibold text-sm uppercase tracking-wider bg-[#ff6b35]/10 px-4 py-2 rounded-full">
              Depoimentos
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1e3a5f]">
            O que nossos <span className="text-[#ff6b35]">clientes</span> dizem
          </h2>
          <div className="flex items-center justify-center space-x-2 text-[#ff6b35]">
            {[...Array(5)].map((_, i) => (
              <Star key={i} size={24} fill="currentColor" />
            ))}
            <span className="text-[#1e3a5f] font-bold text-xl ml-3">4.9/5.0</span>
            <span className="text-gray-600 text-sm">(71 avaliações)</span>
          </div>
        </div>

        {/* Testimonials Carousel */}
        <Carousel
          opts={{
            align: 'start',
            loop: true,
          }}
          className="w-full"
        >
          <CarouselContent>
            {testimonials.map((testimonial, index) => (
              <CarouselItem key={index} className="md:basis-1/2 lg:basis-1/3">
                <div className="p-2">
                  <Card className="h-full bg-white hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-[#ff6b35]/20">
                    <CardContent className="p-6">
                      {/* Quote Icon */}
                      <div className="mb-4">
                        <Quote className="text-[#ff6b35] opacity-30" size={40} />
                      </div>

                      {/* Rating */}
                      <div className="flex space-x-1 mb-4">
                        {[...Array(testimonial.rating)].map((_, i) => (
                          <Star key={i} size={16} className="text-[#ff6b35]" fill="currentColor" />
                        ))}
                      </div>

                      {/* Text */}
                      <p className="text-gray-700 leading-relaxed mb-6 line-clamp-6">{testimonial.text}</p>

                      {/* Author */}
                      <div className="flex items-center space-x-3 pt-4 border-t border-gray-100">
                        <div className="w-10 h-10 bg-gradient-to-br from-[#ff6b35] to-[#48a9a6] rounded-full flex items-center justify-center">
                          <span className="text-white font-bold text-sm">{testimonial.name.charAt(0)}</span>
                        </div>
                        <div>
                          <p className="font-semibold text-[#1e3a5f]">{testimonial.name}</p>
                          <p className="text-xs text-gray-500">Cliente Verificado</p>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious className="-left-12 bg-white shadow-lg border-2 border-[#1e3a5f]/20 hover:bg-[#1e3a5f] hover:text-white" />
          <CarouselNext className="-right-12 bg-white shadow-lg border-2 border-[#1e3a5f]/20 hover:bg-[#1e3a5f] hover:text-white" />
        </Carousel>

        {/* Google Reviews Badge */}
        <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">Avaliado com 4.9 de 5 estrelas no Google</p>
          <div className="inline-flex items-center space-x-2 bg-white px-6 py-3 rounded-full shadow-md">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/c/c1/Google_%22G%22_logo.svg"
              alt="Google"
              className="w-6 h-6"
            />
            <span className="font-semibold text-[#1e3a5f]">71 avaliações</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;